import { CloseOutlined } from '@ant-design/icons';
import { useClickOutside } from '@mm/hooks';
import { useAutomationActions } from '@mm/state/actions/automationActions';
import { IAutomationAction } from '@mm/state/model/AutomationModel';
import classNames from 'classnames';
import React from 'react';
import { useAutomationActionList } from '../use-automation-action-list';
import css from './ActionsList.module.css';
import WidgetModel from '@mm/state/model/WidgetModel';

export const ActionsList = (
  props: IAutomationAction & {
    campaignId: number;
    className?: string;
  },
) => {
  const reduxActions = useAutomationActions();
  const list = useAutomationActionList(props);

  const onCloseClick = () => {
    reduxActions.hideActionsList();
  };

  const ref = useClickOutside<HTMLInputElement>(onCloseClick);

  return (
    <div className={classNames(css.container, props.className)} ref={ref}>
      <div className={css.header}>
        <span className={css.title}>Actions</span>

        <span className={css.close} onClick={onCloseClick}>
          <CloseOutlined />
        </span>
      </div>

      <div className={css.content}>
        <div className={css.list}>
          {Array.isArray(list) &&
            list.map(action => (
              <div
                key={action.name}
                className={classNames(
                  css.item,
                  action?.className ? css[action.className] : '',
                  {
                    [css.disabled]: action.disabled,
                  },
                )}
                style={{ color: action.iconColor }}
                onClick={async () => {
                  if (action.disabled) {
                    return;
                  }

                  const response = await action.add?.(
                    props.dialogueId,
                    props.sortOrder || 0,
                    props.pageGroupId,
                    props.widgetId,
                    props.position,
                  );

                  const widget = response as unknown as WidgetModel;

                  if (widget?.id) {
                    reduxActions.pushActionToOpen({
                      widgetId: widget.id,
                    });
                  }

                  onCloseClick();
                }}
              >
                <span
                  className={css.icon}
                  style={{ background: action.iconBgColor }}
                >
                  <action.icon />
                </span>

                <span className={css.itemTitle}>{action.name}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
